import React, { useCallback, useEffect, useState } from 'react'
import rolesJson from 'components/Users/roles'
import { useTranslation } from 'react-i18next'
import { Form, useFormikContext } from 'formik'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { SelectField } from 'components/Shared/SelectField'
import { useErrorHandling } from 'context/errorHandling'
import { FormColumn, FormRow } from 'components/Shared/CrudComponents'
import Sections from 'components/Users/sections'
import { useAuth, USER_DATA_READ, USER_DATA_WRITE } from 'context/auth'
import { fetchAllGroups } from 'services/GroupsService'
import MultiselectField from 'components/Shared/MultiselectField/MultiselectField'

export function UserForm ({ bottomContent }) {
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()
  const { setFieldValue, values } = useFormikContext()

  const [availableGroups, setAvailableGroups] = useState(null)

  const { handleError } = useErrorHandling()

  const roles = useCallback(() => rolesJson.map(role => ({
    id: role.id,
    label: t(role.label)
  })), [t])

  useEffect(() => {
    fetchAllGroups()
      .then(setAvailableGroups)
      .catch(handleError)
  }, [handleError])

  const defaultRole = useCallback(() => {
    let defaultRole = roles().find(role => role.id === values.role)
    return defaultRole ? defaultRole : roles()[0]
  }, [values.role, roles])

  useEffect(() => {
    setFieldValue('role', defaultRole().id)
  }, [setFieldValue, defaultRole])

  return roles && availableGroups && <Form>
    <FormRow>
      <FormColumn section={Sections.BasicDetails}
                  disabled={!hasAnyPrivileges([USER_DATA_WRITE])}
                  visible={hasAnyPrivileges([USER_DATA_READ])}>
        <SelectField
          data={roles()}
          label={t('user.form.select.role.title')}
          fieldName={'role'}
          setFieldValue={(fieldName, value) => {
            setFieldValue(fieldName, value)
          }}
          defaultValue={defaultRole()}
        />

        <FieldComponent fieldName={'firstName'} label={'user.form.firstName'}/>
        <FieldComponent fieldName={'lastName'} label={'user.form.lastName'}/>
        <FieldComponent fieldName={'phoneNumber'} label={'user.form.phoneNumber'}/>
        <FieldComponent fieldName={'email'} label={'user.form.email'}/>
        <FieldComponent fieldName={'personalPhoneNumber'} label={'user.form.personalPhoneNumber'}/>

        <ControlledSelectField
          options={availableGroups}
          label={t('user.form.select.mainGroup')}
          fieldName={'mainGroupId'}
          onChange={value => {
            setFieldValue('extraGroupsIds', values.extraGroupsIds?.filter(id => id !== value))
          }}
        />

        <MultiselectField
          options={availableGroups}
          label={'user.form.select.extraGroups'}
          fieldName={'extraGroupsIds'}
          onChange={(newValues) => {
            if (newValues.find(group => group.id === values.mainGroupId)) {
              setFieldValue('mainGroupId', null)
            }
          }}/>

        <FieldComponent fieldName={'hash'} label={'user.form.hash'}/>
        <FieldComponent fieldName={'externalId'} label={'user.form.externalId'}/>
      </FormColumn>
      {bottomContent?.()}
    </FormRow>
  </Form>
}
